import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import NotificationActionLayout, { NotificationActionLayoutType } from '~/components/NotificationActionLayout/NotificationActionLayout';
import { useLocationWithState } from '~/hooks/useLocationWithState';
import ApproveAmendmentAction from '~/pages/NotificationAction/ApproveAmendmentAction';
import ApproveInvoiceAction from '~/pages/NotificationAction/ApproveInvoiceAction';
import { notificationSomethingWentWrongContent } from '~/pages/NotificationAction/NotificationAction.utils';
import { NotificationActionType } from '~/pages/NotificationAction/NotificationActionTypes';
import { ApproveTeamMemberInvitation } from './ApproveTeamMemberInvitation';
export const GetNotificationActionPageTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            NotificationActionPageTID: {
                Root: 'notification-action-page'
            }
        }
    });
const NotificationActionPage = ()=>{
    const { state } = useLocationWithState();
    const { NotificationActionPageTID } = useMemo(()=>GetNotificationActionPageTID(), []);
    if (!state) {
        return /*#__PURE__*/ _jsx(NotificationActionLayout, {
            state: {
                type: NotificationActionLayoutType.AfterAction,
                afterAction: notificationSomethingWentWrongContent
            }
        });
    }
    function renderActionComponent(state) {
        switch(state.type){
            case NotificationActionType.ApproveAmendment:
                return /*#__PURE__*/ _jsx(ApproveAmendmentAction, {
                    token: state.token,
                    vendorName: state.vendorName
                });
            case NotificationActionType.ApproveInvoice:
                return /*#__PURE__*/ _jsx(ApproveInvoiceAction, {
                    vendorName: state.vendorName,
                    token: state.token,
                    invoiceFormattedNumber: state.invoiceFormattedNumber,
                    invoiceFormattedAmount: state.invoiceFormattedAmount
                });
            case NotificationActionType.ApproveTeamMemberInvitation:
                return /*#__PURE__*/ _jsx(ApproveTeamMemberInvitation, {
                    invitingUserName: state.invitingUserName,
                    invitingUserEmail: state.invitingUserEmail,
                    invitingBusinessName: state.invitingBusinessName,
                    invitingBusinessId: state.invitingBusinessId,
                    invitationId: state.invitationId
                });
        }
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": NotificationActionPageTID.Root(),
        children: renderActionComponent(state)
    });
};
export default NotificationActionPage;
